import React, { useEffect } from "react";

function Loading() {
  useEffect(() => {
    // 현재 스크롤 위치 저장
    const scrollPosition = window.scrollY;

    // body에 스타일 적용
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = "100%";

    return () => {
      // cleanup: 원래 상태로 복구
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";

      // 스크롤 위치 복구
      window.scrollTo(0, scrollPosition);
    };
  }, []);

  return (
    <div className="z-[1000] fixed top-57 left-0 right-0 bottom-0 max-w-[736px] mx-auto flex justify-center items-center bg-[rgba(255,255,255,0.1)] backdrop-blur-[10px]">
      <div className="loading-logo"></div>
    </div>
  );
}

export default Loading;
